import React, { useMemo } from "react"
import { get } from "lodash"
import { graphql, useStaticQuery } from "gatsby"
// import SEO from "../components/seo"
// import Layout from '../components/layout'
// import PdpNavigation from '../components/slices/PdpNavigation'
// import PdpInfo from '../components/slices/PdpInfo'
// import PdpShipping from '../components/slices/PdpShipping'
import EditorialTextImage from "./slices/EditorialTextImage"
import EditorialImages from "./slices/EditorialImages"
import RelatedProducts from "./slices/RelatedProducts"
import FarmHeader from "./slices/FarmHeader"
import GoogleGallery from "./slices/GoogleGallery"

// Display the title, date, and content of the Post
const FarmLayout = ({ data, isFarmPage, qrCodeLayout }) => {
  // console.log('[FarmLayout.js] data', data)

  const uid = useMemo(() => get(data, "_meta.uid"), [data])

  const dataAllProducts = useStaticQuery(queryAllProducts)
  const allProducts = get(dataAllProducts, "prismic.allProducts.edges")

  // console.log('[FarmLayout.js] allProducts', allProducts)

  const parsedProducts = useMemo(() => {
    if (!allProducts) {
      return null
    }

    return allProducts
      .map(d => {
        const node = d.node
        // const fazenda_uid = get(node, 'fazenda._meta.uid')

        // if(uid != fazenda_uid) {
        //   return []
        // }

        return {
          title: get(node, "title"),
          meta: get(node, "_meta"),
          slug: get(node, "_meta.uid"),
          sku: get(node, "sku"),
          fazenda: get(node, "fazenda"),
          family: get(node, "family"),
          main_image: get(node, "main_image"),
          notes: get(node, "notes"),
          harvest: get(node, "harvest"),
          variety: get(node, "variety"),
          packaging: get(node, "packaging"),
          processing: get(node, "processing"),
          harvest_year: get(node, "harvest_year"),
          altitude: get(node, "altitude"),
          current_location: get(node, "current_location"),
          bags_available: get(node, "bags_available"),
          details: get(node, "details"),
        }
      })
      .sort((a, b) => (a.slug < b.slug ? 1 : b.slug < a.slug ? -1 : 0))
  }, [allProducts])

  let fazendaProducts = []
  parsedProducts.map(p => {
    const fazenda_uid = get(p, "fazenda._meta.uid")
    if (uid === fazenda_uid) {
      fazendaProducts.push(p)
    }
    return null
  })

  const renderContainer = (container, index) => {
    // console.log("container", container.type)

    if (container && container.type === "text___image") {
      return <EditorialTextImage key={index} data={container} index={index} />
    }

    if (container && container.type === "images_editorial" && !qrCodeLayout) {
      return <EditorialImages key={index} data={container} index={index} />
    }

    if (container && container.type === "related_products") {
      return (
        <RelatedProducts
          key={index}
          data={container}
          products={fazendaProducts}
          index={index}
        />
      )
    }

    if (container && container.type === "gallery") {
      return <GoogleGallery key={index} data={container} index={index} />
    }

    return []
  }

  // if(!data) return null;

  return (
    <section className="farm">
      <FarmHeader data={data} isFarmPage={isFarmPage} />

      {data &&
        data?.body?.map((container, index) =>
          renderContainer(container, index)
        )}
    </section>
  )
}

const queryAllProducts = graphql`
  query {
    prismic {
      allProducts {
        edges {
          node {
            _meta {
              uid
              lang
              type
            }
            family {
              ... on PRISMIC_Coffee_family {
                title
                description
                illustration_individual
              }
            }
            title
            sku
            notes {
              note
            }
            # harvest
            # current_location
            # bags_available
            # harvest_year
            # min_order
            # packaging
            # processing
            # status
            # variety
            # altitude
            main_image
            details {
              title1
              text
              show_in_mini_card
            }
            fazenda {
              ... on PRISMIC_Fazenda {
                title
                _linkType
                _meta {
                  uid
                }
                country {
                  ... on PRISMIC_Country {
                    title
                    flag
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export default FarmLayout
